export default "__VITE_PUBLIC_ASSET__43e1aba6__"